export default __webpack_public_path__ + "static/media/mobile.1215c5b0.svg";